import { useFormContext } from "react-hook-form";
import ErrorLabel from "./errorLabel.tsx";

type Props = {
  name: string;
  label: string;
  directions?: string;
};

export default function TextArea({ name, label, directions }: Props) {
  const { register, formState } = useFormContext();
  const fieldError = formState.errors[name]?.message?.toString();

  return (
    <div className="col-span-full">
      <label
        htmlFor={name}
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        {label}
      </label>
      <div className="mt-1">
        <textarea
          id={name}
          rows={3}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-sky-600 sm:text-sm sm:leading-6"
          defaultValue={""}
          {...register(name)}
        />
      </div>
      {directions && (
        <p className="mt-3 text-sm leading-6 text-gray-600">{directions}</p>
      )}
      {fieldError != null && <ErrorLabel message={fieldError} />}
    </div>
  );
}
